/*
 * As bandeiras dos idiomas, separadas do seletor para o site público usar o
 * mesmo desenho sem carregar a sessão e o dicionário do jogo.
 */

/**
 * A bandeira de cada idioma, desenhada em SVG.
 *
 * Não é emoji: no Windows, o Chrome não desenha bandeira por emoji e mostra as
 * duas letras do país no lugar, que é exatamente o contrário do que uma
 * bandeira existe para fazer. Não é imagem, pelo mesmo motivo dos cosméticos:
 * três arquivos binários para três retângulos coloridos custam pedido de rede e
 * não ganham nada.
 *
 * O desenho é simplificado de propósito. Em 22 pixels de largura, a esfera do
 * Brasil, as cinquenta estrelas dos Estados Unidos e o brasão da Espanha viram
 * borrão: o que se reconhece nesse tamanho é a cor e a forma grande.
 */
export function Bandeira({ pais }: { pais: "BR" | "US" | "ES" }) {
  const comum = {
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    style: { display: "block", borderRadius: 2 },
    "aria-hidden": true,
  } as const;

  if (pais === "BR") {
    return (
      <svg {...comum}>
        <rect width="22" height="15" fill="#009b3a" />
        <path d="M11 1.6 20.2 7.5 11 13.4 1.8 7.5Z" fill="#fedf00" />
        <circle cx="11" cy="7.5" r="3.2" fill="#002776" />
      </svg>
    );
  }

  if (pais === "US") {
    return (
      <svg {...comum}>
        <rect width="22" height="15" fill="#fff" />
        {/* Sete faixas vermelhas, que é o que cabe: as treze reais viram
            listra cinza contínua neste tamanho. */}
        {[0, 2, 4, 6, 8, 10, 12].map((y) => (
          <rect key={y} y={y * (15 / 13)} width="22" height={15 / 13} fill="#b22234" />
        ))}
        <rect width="9" height={(15 / 13) * 7} fill="#3c3b6e" />
      </svg>
    );
  }

  return (
    <svg {...comum}>
      <rect width="22" height="15" fill="#aa151b" />
      <rect y="3.75" width="22" height="7.5" fill="#f1bf00" />
    </svg>
  );
}

/** Qual bandeira representa cada idioma. */
export const BANDEIRA: Record<string, "BR" | "US" | "ES"> = {
  "pt-BR": "BR",
  en: "US",
  es: "ES",
};
